import { z } from 'zod';

export const AdminAgenda = z.object({
  id: z.union([z.string(), z.number()]),
  created: z.coerce.date().nullable(),
  orgId: z.number(),
  agendaText: z.string().nullable(),
  relationType: z.enum(['MANAGER', 'SKIP_MANAGER', 'PEER', 'SKIP_REPORTEE', 'REPORTEE']),
  agendaCondition: z.enum([
    'REGULAR',
    'AFTER_REVIEW_PUBLISHED',
    'AFTER_JOINING_WITHIN_30_DAYS',
    'AFTER_JOINING_BETWEEN_30_TO_60_DAYS',
    'AFTER_JOINING_BETWEEN_60_TO_90_DAYS',
  ]),
  displayOrder: z.number().nullable(),
  uiId: z.string().nullable().default(null).optional(),
  isDeleted: z.boolean().nullable().default(false).optional(),
});

export type AdminAgendaType = z.infer<typeof AdminAgenda>;

export const AdminAgendaArray = z.array(AdminAgenda).nullable();
